(function(){
  'use strict';
  function reveal(){
    var els=document.querySelectorAll('.de-rev:not(.is-in)');
    if(!els.length)return;
    if(!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('is-in')});return;}
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if(en.isIntersecting){en.target.classList.add('is-in');io.unobserve(en.target);}
      });
    },{rootMargin:'0px 0px -8% 0px',threshold:.06});
    els.forEach(function(e){io.observe(e)});
  }
  function accordions(root){
    (root||document).querySelectorAll('.de-acc__btn').forEach(function(btn){
      if(btn.dataset.deBound)return; btn.dataset.deBound='1';
      btn.addEventListener('click',function(){
        var panel=btn.parentElement.querySelector('.de-acc__panel');
        var open=btn.getAttribute('aria-expanded')==='true';
        var group=btn.closest('.de-acc');
        if(group&&group.dataset.single==='true'&&!open){
          group.querySelectorAll('.de-acc__btn[aria-expanded="true"]').forEach(function(o){
            o.setAttribute('aria-expanded','false');
            var p=o.parentElement.querySelector('.de-acc__panel'); if(p)p.style.maxHeight='0px';
          });
        }
        btn.setAttribute('aria-expanded',open?'false':'true');
        if(panel)panel.style.maxHeight=open?'0px':panel.scrollHeight+'px';
      });
    });
  }
  function stickyAtc(){
    var bar=document.querySelector('[data-de-sticky-atc]');
    if(!bar)return;
    var anchor=document.querySelector('[data-de-atc-anchor]');
    function upd(){
      var show=false;
      if(anchor){var r=anchor.getBoundingClientRect();show=r.bottom<40;}
      else{show=window.scrollY>600;}
      bar.classList.toggle('is-visible',show);
    }
    upd();
    window.addEventListener('scroll',upd,{passive:true});
    window.addEventListener('resize',upd,{passive:true});
  }
  function qty(){
    document.querySelectorAll('[data-de-qty]').forEach(function(w){
      if(w.dataset.deBound)return; w.dataset.deBound='1';
      var input=w.querySelector('input');
      w.querySelectorAll('button').forEach(function(b){
        b.addEventListener('click',function(e){
          e.preventDefault();
          var v=parseInt(input.value||'1',10);
          v=(b.dataset.deQtyAction==='inc')?v+1:Math.max(1,v-1);
          input.value=v;
          input.dispatchEvent(new Event('change',{bubbles:true}));
        });
      });
    });
  }
  function gallery(){
    document.querySelectorAll('[data-de-gallery]').forEach(function(g){
      if(g.dataset.deBound)return; g.dataset.deBound='1';
      var main=g.querySelector('[data-de-gallery-main] img');
      g.querySelectorAll('[data-de-thumb]').forEach(function(t){
        t.addEventListener('click',function(){
          var src=t.dataset.deThumb; if(!main||!src)return;
          main.src=src; main.srcset='';
          g.querySelectorAll('[data-de-thumb]').forEach(function(x){x.classList.remove('is-active');x.setAttribute('aria-selected','false');});
          t.classList.add('is-active'); t.setAttribute('aria-selected','true');
        });
      });
    });
  }
  function init(){reveal();accordions();stickyAtc();qty();gallery();}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
  document.addEventListener('shopify:section:load',init);
})();
